import { render, staticRenderFns } from "./DnsIssueBody.vue?vue&type=template&id=6b19ba31&scoped=true"
import script from "./DnsIssueBody.vue?vue&type=script&lang=js"
export * from "./DnsIssueBody.vue?vue&type=script&lang=js"
import style0 from "./DnsIssueBody.vue?vue&type=style&index=0&id=6b19ba31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19ba31",
  null
  
)

export default component.exports